import settingIcon from '../../../assets/images/SBA/settings_icons.png';
import clearFilterIcon from '../../../assets/images/SBA/clear_filter.png';
import { getDocumentSummary } from '../services/adminDocuments_service';
import { useEffect,useState } from 'react';
import CustomizeCategoryModal from './modals/CustomizeCategoryModal';

const DocumentsSummaryBar = ({reloadSummary, stopReloadSummary, clearFilters,setReapplyFilters}) => {

  const [summary, setSummary] = useState({
    total: 0,
    published: 0,
    unpublished: 0,
    deleted: 0
  })

  const [showCustomizeModal,setShowCustomizeModal] = useState(false);

  const fetchSummary = async() => {
    try{
        const response = await getDocumentSummary();
        const summaryList = response.data;
        const total = summaryList.find((item)=> item.docStatusId === 99)?.recordCount || 0;
        const published = summaryList.find((item) => item.docStatusId === 1)?.recordCount || 0;
        const unpublished = summaryList.find((item) => item.docStatusId === 2)?.recordCount || 0;
        const deleted = summaryList.find((item) => item.docStatusId === 3)?.recordCount || 0;
        setSummary({
            total:total,
            published: published,
            unpublished: unpublished,
            deleted: deleted
        })
    }
    catch{
        setSummary({
            total:0,
            published: 0,
            unpublished: 0,
            deleted: 0
        })
    }
    stopReloadSummary()
  }

  useEffect(()=>{
    fetchSummary()
  },[])

  useEffect(()=>{
    if(reloadSummary){
      fetchSummary()
    }
  },[reloadSummary])

  return (
    <>
    <div style={{ marginTop: "20px", marginBottom: "10px" }}>

      <span style={{ fontWeight: "bold", color: "#00609e" }}>
        Total: {summary.total} |
      </span>

      <span style={{ marginLeft: "13px", fontWeight: "bold", color: "#00609e" }}>
        <i className="far fa-file-pdf" style={{color:'#129e00',width:'32px',height:'32px'}}></i>
        Published: {summary.published} |
      </span>

      <span style={{ marginLeft: "13px", fontWeight: "bold", color: "#00609e" }}>
        <i className="far fa-file-pdf" style={{color:'#8b8f96',width:'32px',height:'32px'}}></i>
        Unpublished: {summary.unpublished} |
      </span>

      <span style={{ marginLeft: "13px", fontWeight: "bold", color: "#00609e" }}>
        <i className="far fa-file-pdf" style={{color:'#9e1200',width:'32px',height:'32px'}}></i>
        Deleted: {summary.deleted} |
      </span>

      <span style={{ marginLeft: "13px", fontWeight: "bold", color: "#00609e" }}>
        <img src={settingIcon} onClick={() => setShowCustomizeModal(true)}/> |
      </span>

      <span style={{ marginLeft: "13px", color: "#00609e" }}>
        <img src={clearFilterIcon} width={32} height={32} onClick={clearFilters}/> 
      </span>

    </div>
    {showCustomizeModal &&
    <CustomizeCategoryModal
  show={showCustomizeModal}
  onClose={() => setShowCustomizeModal(false)}
  setReapplyFilters={setReapplyFilters}
/>}
    </>
  );
};

export default DocumentsSummaryBar;